/**
 * DD discount / sticky footer widget
 */
document.addEventListener("DOMContentLoaded", () => {
  const tieredWidget = document.querySelector("#tiered-widget");
  if (!tieredWidget) return;

  // add css class for extra margin
  document.body.classList.add("has-dd-tiers");

  const progressBar = tieredWidget.querySelector(
    ".tiered-widget__progress-bar"
  );
  const targetNode = document.querySelector(".quick-cart__container");
  const atcButtonTotal = tieredWidget.querySelector("[data-cart-total]");
  const atcButtonCount = tieredWidget.querySelector("[data-cart-item-count]");
  const qualified = tieredWidget.querySelector("[data-tier-qualified]");
  const isCashValue = tieredWidget.dataset.cashValue === "true";
  const currencySymbol = tieredWidget.dataset.currencySymbol;
  const cartTrigger = tieredWidget.querySelector("[data-sticky-cart]");
  const quickAdd = tieredWidget.querySelector("[data-sticky-add]");

  // atc
  if (quickAdd) {
    window.theme.ProductItem(quickAdd);
    quickAdd.addEventListener("click", () => {
      tieredWidget
        ?.querySelector(".continue-shopping")
        ?.classList.remove("hidden");
    });
  }

  // cart trigger
  cartTrigger?.addEventListener("click", function (e) {
    e.preventDefault();
    const quickCartWrapper = document.querySelector(".quick-cart__wrapper");
    if (!quickCartWrapper) return;
    quickCartWrapper.classList.add("active");
  });

  // handle js add to cart events
  let discountProducts = [];
  try {
    discountProducts = JSON.parse(
      document.querySelector("[data-discount-products]")?.innerText
    );
  } catch (e) {}

  const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      const qualifyingValueCount = window.theme.cartData.items?.reduce(
        (acc, item) =>
          discountProducts?.includes(item?.handle)
            ? acc + (isCashValue ? item.original_line_price : item.quantity)
            : acc,
        0
      );

      // update the cart total button
      const total = (window.theme.cartData.items_subtotal_price / 100).toFixed(
        2
      );
      const count = window.theme.cartData.item_count;
      if (atcButtonCount) {
        atcButtonCount.innerText = count;
        atcButtonTotal.innerText = window.theme.moneyFormat.replace(
          /\{\{(.+?)\}\}/g,
          total
        );
      }

      // update the discounts
      if (!discountProducts.length) return;
      let threshold = 0;
      let lastThreshold = 0;

      const totalQualified = Number(qualified.dataset.tierQualified || 0);
      const minQualified = Number(qualified.dataset.min || 0);

      Array.from(progressBar.children || [])?.forEach((item) => {
        if (item.hasAttribute("data-tier-qualified")) return;

        lastThreshold = threshold;
        threshold = Number(item.dataset.total);

        // update the widget
        if (
          qualifyingValueCount < threshold &&
          qualifyingValueCount >= lastThreshold
        ) {
          const thresholdMax = threshold - lastThreshold - 0.9;
          const percent =
            ((qualifyingValueCount - lastThreshold) / thresholdMax) * 100;
          const progressBarSpan = item?.querySelector(".dd-chip--progress");
          const displayValue = isCashValue
            ? `${currencySymbol}${(qualifyingValueCount / 100).toFixed(2)}`
            : qualifyingValueCount;
          const displayThreshold = isCashValue
            ? `${currencySymbol}${(threshold / 100).toFixed(2)}`
            : threshold;
          item.classList.add("current");

          if (!progressBarSpan) {
            const node = document.createElement("DIV");
            node.classList.add(
              "dd-chip",
              "dd-chip--white",
              "dd-chip--progress"
            );
            node.setAttribute(
              "style",
              `--progress-width: calc(${percent}% - 15px)`
            );
            node.innerHTML = `<div class="dd-chip dd-chip--white">${displayValue} / ${displayThreshold}</div>`;
            item.prepend(node);
          } else {
            progressBarSpan.setAttribute(
              "style",
              `--progress-width: calc(${percent}% - 15px)`
            );
            progressBarSpan.innerHTML = `<div class="dd-chip dd-chip--white">${displayValue} / ${displayThreshold}</div>`;
          }
        } else {
          item.classList.remove("current");
          item.querySelector(".dd-chip--progress")?.remove();
        }

        if (qualifyingValueCount >= threshold) {
          item.classList.add("dd-chip--qualified");
        } else {
          item.classList.remove("dd-chip--qualified");
        }

        if (qualifyingValueCount >= totalQualified) {
          qualified.classList.remove("hidden");
        } else {
          qualified.classList.add("hidden");
        }
      });
    }
  });
  observer.observe(targetNode, {
    attributes: false,
    childList: true,
    subtree: true,
  });
});

/**
 * Filter bar
 */
document.addEventListener("DOMContentLoaded", () => {
  const tieredWidget = document.querySelector("#tiered-widget");
  if (!tieredWidget) return;
  const drawerToggleEl = tieredWidget.querySelector("[data-drawer-toggle]");
  const drawerEl = document.querySelector("[data-filter-drawer]");

  const showDrawer = () => {
    if (drawerToggleEl) {
      drawerToggleEl.setAttribute("aria-expanded", true);
    }
    drawerEl.setAttribute("aria-hidden", false);
    document.body.setAttribute("data-drawer-modal-open", "true");
  };

  const hideDrawer = () => {
    if (drawerToggleEl) {
      drawerToggleEl.setAttribute("aria-expanded", false);
    }
    drawerEl.setAttribute("aria-hidden", true);

    // Delay by 500ms to allow the drawer to close before any CSS styles are applied.
    setTimeout(() => {
      document.body.setAttribute("data-drawer-modal-open", "false");
    }, 500);
  };

  const toggleDrawer = () => {
    var ariaHidden = drawerEl.getAttribute("aria-hidden") === "true";
    if (ariaHidden) {
      showDrawer();
    } else {
      hideDrawer();
    }
  };

  drawerToggleEl?.addEventListener("click", toggleDrawer);

  // update results text
  const footerApply = window.document.querySelector('.filter-drawer__footer [data-filter-drawer-apply]');
  if (footerApply) {
    const observer = new MutationObserver(function(mutationsList) {
      if (mutationsList?.[0]?.addedNodes?.length) {
        Array.from(mutationsList?.[0]?.addedNodes, node => {
          if (node.classList && node.classList.contains("filter-drawer__button-apply-text")) {
            const resElem = document.querySelector("[data-results-count-sticky]");
            const updatedResults = node.innerText.split('(')?.[1].replace(")", "") || 0;
            if (resElem) {
              resElem.innerText = `(${updatedResults})`;
            }
          }
        })
      }
    });
    observer.observe(footerApply, {characterData: true, childList: true, attributes: true});
  }
});

/**
 * Sticky quick links handler
 */
(function() {
  const main = document.querySelector("main.main")
  const quickLinks = document.querySelector(".quick-links")
  let announcementHeight = 34
  let quickLinksHeight = 63
  let isSticky = false

  if (!quickLinks.classList.contains("quick-links__sticky")) return

  function handleStickyLinks(_, firstLoad = false) {
    if (!isSticky && window.scrollY > announcementHeight) {
      isSticky = true
      document.documentElement.classList.add("announcement-scrolled")
      main?.setAttribute("style", `margin-top: ${quickLinksHeight}px`)
    } else if (isSticky && window.scrollY <= announcementHeight) {
      isSticky = false
      document.documentElement.classList.remove("announcement-scrolled")
      main?.removeAttribute("style")
    }
    if (firstLoad) {
      setTimeout(() => {
        document.documentElement.classList.remove("announcement-first-load")
      }, 300)
    }
  }

  function calculateHeights() {
    announcementHeight = Number(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')?.replace("px", "") || 34)
    quickLinksHeight = document.querySelector(".quick-links")?.getBoundingClientRect()?.height || 63
  }

  window.addEventListener("scroll", handleStickyLinks)
  window.addEventListener("resize", calculateHeights)
  calculateHeights()
  handleStickyLinks(null, true)
})();